import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";

// Components
import Loader from "../../utils/Loader";
import ErrorText from "../../utils/error-success/ErrorText";
import ErrorDialog from "../../utils/dialogs/ErrorDialog";
import SuccessWrap from "../../utils/error-success/SuccessWrap";
import TranslationItem from "./TranslationItem";

// State
import { userTokenUpdate, userLogout } from "../../../store/actions/user";
import { getAuthHeader } from "../../../store/headers";

class TranslationSection extends Component {
	constructor(props) {
		super(props);

		this.state = {
			id: this.props.match.params.id,
			isLoading: true,
			data: [],
			showErrorDialog: false
		};
	}

	componentDidMount() {
		this.loadData();
	}

	loadData = () => {
		const { id } = this.state;

		const apiEndpoint = "translations/sections/" + id;

		const params = { language: process.env.REACT_APP_LANGUAGE };

		return axios
			.get(process.env.REACT_APP_API_URL + apiEndpoint, {
				headers: getAuthHeader(this.props.user, true),
				params
			})
			.then(response => {
				if (
					response.status !== 200 ||
					(response.data.status && response.data.status !== 200)
				) {
					this.setState({ isLoading: false, error: response.data.message });
				} else {
					this.setState({ isLoading: false, data: [...response.data] });
				}
			})
			.catch(err => {
				if (err.response) {
					this.setState({
						isLoading: false,
						error: err.response.data.errors
							? err.response.data.errors
							: err.response.data.message
					});
				} else {
					this.setState({ isLoading: false, error: err.message });
				}
			});
	};

	// ===================================================================================
	//  INPUT HANDLING
	// ===================================================================================
	editorChange = (event, id, index) => {
		const newContent = event.editor.getData();

		// If the editor hasn't actually changed, bail!
		// This get's triggered for whatever reason after an item is added/deleted.
		// if ((newContent, this.state.data[index][id])) return false;

		this.setState({
			data: [
				...this.state.data.map((item, i) => {
					if (i !== index) {
						return item;
					}

					return {
						...item,
						[id]: newContent,
						titleChanged: true
					};
				})
			]
		});
	};

	updateText = (event, index) => {
		const { id, value } = event.target;

		this.setState({
			data: [
				...this.state.data.map((item, i) => {
					if (i !== index) {
						return item;
					}

					return {
						...item,
						[id]: value,
						titleChanged: true
					};
				})
			]
		});
	};

	// ===================================================================================
	//  SUBMIT
	// ===================================================================================
	handleSubmit = sectionItem => {
		let itemIndex = null;

		// Set state of saving group
		const savedDocState = this.state.data.map((item, i) => {
			if (item.id !== sectionItem.id) {
				return item;
			}

			itemIndex = i;

			return { ...item, saving: true, successfull: false };
		});

		this.setState(
			{
				data: [...savedDocState]
			},
			() => {
				const { user } = this.props;
				const data = {
					id: sectionItem.id,
					value: sectionItem.value
				};

				// Add language to data
				data.language = process.env.REACT_APP_LANGUAGE;

				// const data = { ...editedItem };

				return axios
					.post(process.env.REACT_APP_API_URL + "translations", data, {
						headers: getAuthHeader(user, true)
					})
					.then(response => {
						if (!!response.data.token) {
							this.props.userTokenUpdate("admin", response.data.token);
						}

						// ===================================
						//  ERROR
						// ===================================
						if (
							response.status !== 200 ||
							(response.data.status && response.data.status !== 200)
						) {
							this.setState({
								showErrorDialog: true,
								errors: response.data.errors
							});

							this.resetItemState(itemIndex);
						}
						// ===================================
						//  SUCCESS
						// ===================================
						else {
							// Reset saving status for group
							this.resetItemState(itemIndex, true, response.item);
						}
					})
					.catch(err => {
						this.setState({
							showErrorDialog: true,
							errors: err.toString()
						});
						this.resetItemState(itemIndex);
					});
			}
		);
	};

	resetItemState = (itemIndex, successfull = false, newItem = null) => {
		this.setState({
			data: [
				...this.state.data.map((alteredItem, i) => {
					if (i !== itemIndex) {
						return alteredItem;
					}

					const item = newItem === null ? alteredItem : newItem;

					return {
						...item,
						saving: false,
						deleting: false,
						successfull,
						titleChanged: !successfull
					};
				})
			]
		});
	};

	// ===================================================================================
	//  RENDER
	// ===================================================================================
	render() {
		return (
			<React.Fragment>
				{this.state.error ? (
					<ErrorText errors={this.state.error} />
				) : this.state.isLoading ? (
					<div className="pt2 pb2">
						<Loader />
					</div>
				) : (
					<React.Fragment>
						{this.state.data.length ? (
							<React.Fragment>
								{this.state.updateSuccess && (
									<SuccessWrap animate={1}>
										{this.state.updateSuccess}
									</SuccessWrap>
								)}

								{this.state.data.map((item, i) => (
									<TranslationItem
										key={item.id}
										item={item}
										editorChange={(e, id) => this.editorChange(e, id, i)}
										handleInputChange={e => this.updateText(e, i)}
										saveHandler={() => this.handleSubmit(item)}
									/>
								))}
							</React.Fragment>
						) : (
							<div>Unable to find the section you were looking for.</div>
						)}
						<ErrorDialog
							show={this.state.showErrorDialog}
							errors={this.state.errors}
							handleClose={() => this.setState({ showErrorDialog: false })}
						/>
					</React.Fragment>
				)}
			</React.Fragment>
		);
	}
}

const mapStateToProps = state => {
	return {
		user: state.user
	};
};

export default connect(
	mapStateToProps,
	{ userTokenUpdate, userLogout }
)(TranslationSection);



// WEBPACK FOOTER //
// ./src/components/admin/translations/TranslationSection.js